export default __webpack_public_path__ + "static/media/credit-card.78680288.svg";